import { render, staticRenderFns } from "./VibrationIcon.vue?vue&type=template&id=32ba4780&scoped=true&"
import script from "./VibrationIcon.vue?vue&type=script&lang=js&"
export * from "./VibrationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba4780",
  null
  
)

export default component.exports